module.exports = __webpack_public_path__ + "img/Galles.8d2f4506.png";